import { z } from "zod";

const isoDateString = z.string().refine(value => !Number.isNaN(Date.parse(value)), "Must be a valid date");

export const listingCreateSchema = z.object({
  ndc: z.string().regex(/^\d{5}-\d{4}-\d{2}$/, "NDC must use 00000-0000-00 format"),
  name: z.string().min(1),
  dosage: z.string().min(1),
  lot: z.string().min(1),
  unitPrice: z.number().positive(),
  quantity: z.number().int().positive(),
  expiresAt: isoDateString,
  sellerId: z.string().min(1),
  shipsInHours: z.number().int().positive().max(168),
  tags: z.array(z.string()).default([]),
});

export const listingFilterSchema = z.object({
  query: z.string().optional(),
  packetReady: z.boolean().optional(),
  shortageOnly: z.boolean().optional(),
  brandOnly: z.boolean().optional(),
  shipsWithinHours: z.number().int().positive().optional(),
});

export type ListingCreateInput = z.infer<typeof listingCreateSchema>;
export type ListingFilters = z.infer<typeof listingFilterSchema>;
